import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { CHECKOUT_URL } from '../constants';
export function StickyCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      // Show the sticky bar after the user scrolls past the first viewport
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-15">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pointer-events-none" data-id="element-16">
          <a href={CHECKOUT_URL} className="pointer-events-auto group mx-auto flex w-full max-w-3xl items-center justify-center gap-3 rounded-2xl bg-yellow-400 px-5 py-4 text-center text-lg md:text-xl font-black text-gray-900 shadow-2xl border-b-4 border-yellow-600 transition-all duration-200 hover:bg-yellow-300 hover:-translate-y-0.5 active:translate-y-0.5" data-id="element-17">
            <span data-id="element-18">👉 Sí, quiero mis 500 juegos por solo $12 USD</span>
            <ArrowRight className="w-6 h-6 flex-shrink-0 transition-transform group-hover:translate-x-1" data-id="element-19" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}